export enum EnumStatusBoleto {
    INVALIDO = 'INVALIDO',
    NAO_REGISTRADO = 'NAO_REGISTRADO',
    NAO_ENCONTRADO = 'NAO_ENCONTRADO',
    IMPAGAVEL = 'IMPAGAVEL',
    PAGO = 'PAGO',
    NAO_PAGO = 'NAO_PAGO',
}



// WEBPACK FOOTER //
// ./src/app/resources/enum/enumStatusBoleto.ts